import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';
const scene = new THREE.Scene();
const loader = new GLTFLoader();
const camera = new THREE.PerspectiveCamera( 50, 1, 0.1, 1000 );

// if(wrapper.classList.contains("desktop") && window.innerWidth < 768){
//     return;
// };

//on DOMContentLoaded
const wrapper = document.querySelector(".threejs-image-wrapper");

//when the wrapper is in view, run the script
if(wrapper){
    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if(entry.isIntersecting){
                runThreeScript();
                observer.unobserve(entry.target);
            }
        });
    }, {
        rootMargin: "0px 0px 0px 0px"
    });

    observer.observe(wrapper);
}

const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
const mobileSafari = isSafari && window.innerWidth < 768;
const runThreeScript = () => {
    console.log("running 3d script");
    const renderer = new THREE.WebGLRenderer( { alpha: true } );
    renderer.setPixelRatio( mobileSafari ? 1 : window.devicePixelRatio );
    const wrapperBox = wrapper.getBoundingClientRect();

    renderer.setSize( 
        wrapperBox.width/2, 
        wrapperBox.width/2
    );
        // wrapperBox.height);
    const fileUrl = wrapper.getAttribute("data-url");
    const alignment = wrapper.getAttribute("data-align");
    const cubemapSides = wrapper.getAttribute("data-cubemap-sides");
    const goldCubemapSides = wrapper.getAttribute("data-gold-cubemap-sides");
    const cubemapSide2 = wrapper.getAttribute("data-cubemap-side-2");
    const goldCubemapSide2 = wrapper.getAttribute("data-gold-cubemap-side-2");
    const cubemapSide3 = wrapper.getAttribute("data-cubemap-side-3");
    const goldCubemapSide3 = wrapper.getAttribute("data-gold-cubemap-side-3");
    const cubemapSide4 = wrapper.getAttribute("data-cubemap-side-4");
    const goldCubemapSide4 = wrapper.getAttribute("data-gold-cubemap-side-4");
    const cubemapCeiling = wrapper.getAttribute("data-cubemap-ceiling");
    const goldCubemapCeiling = wrapper.getAttribute("data-gold-cubemap-ceiling");
    const cubeMapFloor = wrapper.getAttribute("data-cubemap-floor");
    const goldCubeMapFloor = wrapper.getAttribute("data-gold-cubemap-floor");
    let color = parseInt(wrapper.getAttribute("data-3d-color"));

    if(!color){
        color = 0xffffff;
    }
    renderer.domElement.classList.add(alignment);
    // renderer.domElement.style.transform = "translateX(-50%)";
    wrapper.appendChild( renderer.domElement );

    const hemiLight = new THREE.HemisphereLight( 0xffffff, 0xffffff, 0.6 );
    // hemiLight.color.setHSV( 0.6, 0.75, 0.5 );
    // hemiLight.groundColor.setHSV( 0.095, 0.5, 0.5 );
    // hemiLight.position.set( 0, 500, 0 );
    // scene.add( hemiLight );

    const envUrls = [
        cubemapSides, cubemapSide2, 
        cubemapCeiling, cubeMapFloor,
        cubemapSide3,cubemapSide4
    ];

    const goldUrls = [
        goldCubemapSides, goldCubemapSide2,
        goldCubemapCeiling, goldCubeMapFloor,
        goldCubemapSide3, goldCubemapSide4
    ];

    // console.log(color, 0xFFD700);

    const reflectionCube = new THREE.CubeTextureLoader().load( color === 0xffffff ? envUrls : goldUrls );
    // const refractionCube = new THREE.CubeTextureLoader().load( envUrls );
    // refractionCube.mapping = THREE.CubeRefractionMapping;

    const geometry = new THREE.BoxGeometry( 1, 1, 1 );
    const material = new THREE.MeshPhysicalMaterial(
        mobileSafari ? {
            color,
            // color:0xffffff, //silver 
            // color: 0xFFD700, //gold
            // emissive: 0xFFD70099,
            roughness: .15,
            metalness: .7,
            // ior: 1,
            // clearcoat: 1,
            // reflectivity: 1,
            envMapIntensity: 1,

            envMap: reflectionCube,
        // emissive: 0x878787
    } : {
        color,
        // color:0xffffff, //silver 
        // color: 0xFFD700, //gold
        // emissive: 0xFFD70099,
        roughness: .125,
        metalness: 1,
        ior: 1,
        clearcoat: 1,
        reflectivity: 1,
        envMapIntensity: 1,

        envMap: reflectionCube,
    // emissive: 0x878787
}
);


    // Add a light

    const ambientLight = new THREE.AmbientLight(0xffffff, 1); // Soft white light
    scene.add(ambientLight);


    // const directionalLight = new THREE.DirectionalLight(0xffffff, 3);
    // directionalLight.position.set(5, 5, 5).normalize();
    // scene.add(directionalLight);
    //using the three lines above create a loop to create 4x4 grid of lights centered above the model

    let mobile = window.innerWidth < 768;

    let amount = mobile ? 1 : 3;
    for (let i = 0; i < amount; i++) {
        for (let j = 0; j < amount; j++) {
            const light = new THREE.DirectionalLight(0xffffff, .1);
            light.position.set(i*5  - (amount*2.5), 35, j * 30- (amount*10));
            scene.add(light);
        }
    }

    //fileUrl is a .glb file. import it into the scene and add it to the scene
    let scale = 125;
    let model;
    let pivot = new THREE.Object3D(); // Create a pivot object
    let size;
    scene.add(pivot);

    loader.load(fileUrl, function (gltf) {
        model = gltf.scene;
        model.scale.set(scale, scale, scale);

        //log dimensions of the model
        const boxx = new THREE.Box3().setFromObject(model);
        size = new THREE.Vector3();
        boxx.getSize(size);
        // renderer.setSize( 
        //     wrapperBox.width, 
        //     (wrapperBox.width/size.x) * size.y
        // );

        model.rotation.x = -.2;
        

        // Compute the bounding box of the model
        const box = new THREE.Box3().setFromObject(model);
        const center = box.getCenter(new THREE.Vector3());

        

        // Center the model
        model.position.x += (model.position.x - center.x);
        model.position.y += (model.position.y - center.y);
        model.position.z += (model.position.z - center.z);

        

        model.traverse((child) => {
            if (child.isMesh) {
                child.material = material;
                child.material.needsUpdate = true;
            }
        });

        //zoom camera out based on size of model
        camera.position.z = size.length() * 1.2;


        // Add the model to the pivot
        pivot.add(model);

        // Optionally, adjust the camera position based on the size of the model
        // light.position.set(center.x, center.y, center.z-4);
        // camera.position.z = size.length() * 1.5;
    });

    // Function to change the color of the material
    window.changeMaterialColor = function (color) {
        if (model) {
            model.traverse((child) => {
                if (child.isMesh) {
                    child.material.color.set(color);

                    child.material.needsUpdate = true;
                }
            });
        }
    };

    window.toggleEnvMap = function (isGold) {
        if (isGold) {
            material.envMap = new THREE.CubeTextureLoader().load( goldUrls );
        } else {
            material.envMap = new THREE.CubeTextureLoader().load( envUrls );
        }
        material.needsUpdate = true;
    }

    window.changeReflectiveness = function (isGold) {
        //if gold, make the material less reflective
        if (isGold) {
            material.roughness = .25;
            material.metalness = .5;
        } else {
            material.roughness = .125;
            material.metalness = 1;
        }
        material.needsUpdate = true;
    }

    let animating = true;


    let rotationDelta = {
        x: 0,
        y: -0.0025
    }

    let rotationTarget = {
        x: 0,
        y: 0
    }

    let rubberBanding = window.innerWidth > 768 ? 0.1 : 0.25;

    function animate() {
        if (pivot) {
            // pivot.rotation.y += 0.01;
            pivot.rotation.y += rotationDelta.y;
            pivot.rotation.x += rotationDelta.x;

            if(rotationTarget.x && rotationTarget.y){
                rotationDelta.x = (rotationTarget.x - pivot.rotation.x) * rubberBanding;
                rotationDelta.y = (rotationTarget.y - pivot.rotation.y) * rubberBanding;
            } else {
                rotationDelta.x = (rotationTarget.x - pivot.rotation.x) * rubberBanding;
            }
            // pivot.rotation.z -= 0.001;
            // light.rotation.y += 0.01;
        }
        renderer.render(scene, camera);
    }

    //as mouse moves over canvas, rotate the model
    let isDragging = false;
    let accumulatedSpin = 0;
    let previousMousePosition = {
        x: 0,
        y: 0
    };

    //when mouseenter, stop animating, and when mouseleave, start animating
    renderer.domElement.addEventListener('mouseenter', e => {
        animating = false;
        // rotationTarget.y = Math.round(pivot.rotation.y / (Math.PI * 2)) * (Math.PI * 2);
        accumulatedSpin = Math.round(pivot.rotation.y / (Math.PI * -2)) * (Math.PI * -2);
    });

    renderer.domElement.addEventListener('mouseleave', e => {
        animating = true;
        // pivot.rotation.x = 0;
        rotationTarget.x = 0;
        //round down to closest multiple of 360
        // rotationTarget.y = Math.round(pivot.rotation.y / (Math.PI * 2)) * (Math.PI * 2);
        rotationDelta.y = -0.0025;
        rotationDelta.x = 0;
    });

    renderer.domElement.addEventListener('mousedown', e => {
        isDragging = true;
    });
    renderer.domElement.addEventListener('mouseup', e => {
        isDragging = false;
    });

    if(mobile) {
        camera.position.z = 8;
    }

    function mouseMove(e) {
        //listener that takes the mouse position from x:-1,y:-1 to x:1,y:1 of the canvas.
        //that determines the rotation of the models x/y rotation, with a max of n degrees set by a variable. 
        //the model's exact rotation corresponds with the position of the mouse

        const percentagePosition = {
            x: (e.offsetX / renderer.domElement.clientWidth) * 2 - 1,
            y: (e.offsetY / renderer.domElement.clientHeight) * 2 - 1
        };

        // Calculate the desired rotation based on the mouse position
        const maxRotation = 55; // Maximum rotation in degrees
        const targetRotationX = toRadians(percentagePosition.y * maxRotation);
        const targetRotationY = accumulatedSpin + toRadians(percentagePosition.x * maxRotation);

        // Set the rotation of the pivot object
        // updateRotationAnimationDestination(targetRotationX, targetRotationY,);
        // pivot.rotation.x = targetRotationX;
        // pivot.rotation.y = targetRotationY;
        rotationTarget.x = targetRotationX;
        rotationTarget.y = targetRotationY;

    }

    function touchMove(x,y) {
        console.log("movin!")
        //listener that takes the mouse position from x:-1,y:-1 to x:1,y:1 of the canvas.
        //that determines the rotation of the models x/y rotation, with a max of n degrees set by a variable. 
        //the model's exact rotation corresponds with the position of the mouse

        const percentagePosition = {
            x,
            y
        };

        // Calculate the desired rotation based on the mouse position
        const maxRotation = 55; // Maximum rotation in degrees
        const maxRotationX = 95;
        const targetRotationX = accumulatedSpin + toRadians(percentagePosition.y * maxRotation);
        const targetRotationY =  toRadians(percentagePosition.x * maxRotationX);

        // Set the rotation of the pivot object
        // updateRotationAnimationDestination(targetRotationX, targetRotationY,);
        // pivot.rotation.x = targetRotationX;
        // pivot.rotation.y = targetRotationY;
        rotationTarget.x = targetRotationX;
        rotationTarget.y = targetRotationY;

    }


    let touchStart = {x: 0, y: 0};

    renderer.domElement.addEventListener('mousemove', mouseMove);
    //touch events

    renderer.domElement.addEventListener('touchstart', e => {
        isDragging = true;
        const touch = e.touches[0];
        touchStart = {x: touch.clientX, y: touch.clientY};
    });
    renderer.domElement.addEventListener('touchend', e => {
        animating = true;
        // pivot.rotation.x = 0;
        rotationTarget.x = 0;
        //round down to closest multiple of 360
        // rotationTarget.y = Math.round(pivot.rotation.y / (Math.PI * 2)) * (Math.PI * 2);
        rotationDelta.y = -0.0025;
        rotationDelta.x = 0;
    });

    let mobileDragTimeout;
    let maxTouchMovement = 50;
    let box = renderer.domElement.getBoundingClientRect();
    let clientWidth;
    console.log(renderer.domElement);
    renderer.domElement.addEventListener('touchmove', e => {
        if(!clientWidth){
            clientWidth = renderer.domElement.clientWidth;
        }
        //if touching in outer 20% of element, preventDefault() and return
        //get percent x y offset of canvas
        // console.log(box,e)

        if(box.left+clientWidth * .1 > e.touches[0].clientX || e.touches[0].clientX > box.left + clientWidth * .9){
            console.log(box.left+clientWidth * .1, e.touches[0].clientX, box.left + clientWidth * .9);
        }

        if(mobileDragTimeout){
            clearTimeout(mobileDragTimeout);
        }
        e.preventDefault();
        // if(e.touches[0].clientX < (box.left + clientWidth * .1) || e.touches[0].clientX > box.left + clientWidth * .1){
        //     console.log(box,Math.floor(e.touches[0].clientX), Math.floor(box.left + clientWidth * .1), Math.floor(box.left + clientWidth * .9));
        //     return;
        // }
        const touch = e.touches[0];
        const touchDelta = {
            x: (touch.clientX - touchStart.x),
            y: (touch.clientY - touchStart.y)
        };
        // const offsetX = touch.clientX - renderer.domElement.getBoundingClientRect().left;
        // const offsetY = touch.clientY - renderer.domElement.getBoundingClientRect().top;
        //touchMove takes total rotation in x and y between -1 and 1
        touchMove(Math.min(Math.max(touchDelta.x / maxTouchMovement,-1),1), Math.min(Math.max(touchDelta.y / maxTouchMovement,-1),1));
        if(mobileDragTimeout){
            clearTimeout(mobileDragTimeout);
        }
        mobileDragTimeout = setTimeout(() => {
            isDragging = false;
        }, 500);
    });

    const rotationAnimationIncrement = .1;

    function updateRotationAnimationDestination(targetRotationX, targetRotationY) {
        // Update the destination rotation of the pivot object
        let currentRotationX = pivot.rotation.x;
        let currentRotationY = pivot.rotation.y;
        //increment rotation in x,y towards the target
        if (currentRotationX < targetRotationX) {
            pivot.rotation.x += rotationAnimationIncrement;
        } else if (currentRotationX > targetRotationX) {
            pivot.rotation.x -= rotationAnimationIncrement;
        }
        if(currentRotationY < targetRotationY){
            pivot.rotation.y += rotationAnimationIncrement;
        }
        else if(currentRotationY > targetRotationY){
            pivot.rotation.y -= rotationAnimationIncrement;
        }
    }



    function toRadians(angle) {
        return angle * (Math.PI / 180);
    }

    function setRendererSize() {
        const wrapperBox = wrapper.getBoundingClientRect();
        const width = wrapper.getAttribute("data-width");
        // console.log({width, wr: wrapperBox.width});
        renderer.setSize(
            width ? (parseInt(width) / 100) * wrapperBox.width : wrapperBox.width,
            width ? (parseInt(width) / 100) * wrapperBox.width : wrapperBox.width
        );
    }

    setRendererSize();

    renderer.setAnimationLoop( animate );



    window.addEventListener('resize', () => {
        // const boxx = new THREE.Box3().setFromObject(model);
        // size = new THREE.Vector3();
        // boxx.getSize(size);
        // size = new THREE.Vector3();

        // camera.aspect = window.innerWidth / window.innerHeight;
        if(window.innerWidth < 768 && size){
            // camera.position.z = size.length() * 1.2;
            // camera.position.z = 8;
        }
        camera.updateProjectionMatrix();
        setRendererSize();
    });

    //prevent right clicking on renderer.domElement
    renderer.domElement.addEventListener('contextmenu', e => e.preventDefault());

};